import graphqlClient from '~/graphql/graphqlClient';

export interface MutationDowngradeAttributeArgs {
  playerId: string;
  heroHandle: string;
  attributeHandle: string;
  heroBuildId: string;
}

export interface AttributeChangeResult {
  heroHandle: string;
  heroBuild: any;
}

const mutation = `
mutation DowngradeAttribute(
  $playerId: String!
  $heroHandle: String!
  $attributeHandle: String!
  $heroBuildId: String!
) {
  downgradeAttribute(
    playerId: $playerId
    heroHandle: $heroHandle
    attributeHandle: $attributeHandle
    heroBuildId: $heroBuildId
  ) {
    heroHandle
    heroBuild
  }
}`;

export default async function mutationDowngradeAttribute(args: MutationDowngradeAttributeArgs) {
  return await graphqlClient.request<AttributeChangeResult>('downgradeAttribute', mutation, args);
}
